import React, { Component } from 'react'
import sortBy from 'lodash/sortBy'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import { Link } from 'gatsby'
import PageLayout from './PageLayout'
import Breadcrumb from '../common/Breadcrumb'
import { AZFilterList } from '../common'
import { CONTENTFUL_GRAPHQL_TYPES, buildURL } from '../../utils/url'
import * as SearchHelper from '../../helpers/SearchHelper'
class DirectoryOfServicesLayout extends Component {
    constructor(props) {
        super(props)
        const externalLinks = props.page.links?.filter((link) => link.__typename === CONTENTFUL_GRAPHQL_TYPES.LINK || link.__typename === CONTENTFUL_GRAPHQL_TYPES.LINK_PTP).map((link) => ({ name: link.text, url: link.url, external: true }))
        const internalLinks = props.page.links?.filter((link) => link.__typename !== CONTENTFUL_GRAPHQL_TYPES.LINK || link.__typename !== CONTENTFUL_GRAPHQL_TYPES.LINK_PTP).map((link) => ({ name: link.title, url: buildURL(link) }))
        const links = sortBy([...internalLinks, ...externalLinks], ['name'])
        this.state = {
            links,
            index: null,
        }
    }
    static getDerivedStateFromProps(props) {
        const queryParams = SearchHelper.queryParamsToObject(props.location.search)
        const index = get(queryParams, 'index')
        return {
            index,
        }
    }
    render() {
        const { site, page, preview, sitemap, className, title } = this.props
        const { links, index } = this.state
        const activeSection = page ? page.userSection : ''
        const description = get(page.description, 'description', '') ? get(page.description, 'description') : get(page, 'description', '')
        const titlePrefix = className?.includes('ptp-root') ? 'Power To Protect' : 'Starship'
        const pageTitle = `${titlePrefix} - ${page.title}`
        return (
            <PageLayout className={`guideline-list directory ${className} `} activeSection={activeSection} sitemap={sitemap}>
                <Helmet title={pageTitle} />
                <Breadcrumb page={{ title: page.title, slug: page.slug, __typename: CONTENTFUL_GRAPHQL_TYPES.GENERIC_PAGE, userSection: page.userSection }} />
                <main>
                    <div className="guideline content wrapper">
                        <h2>{page.title}</h2>
                        <h4>{description}</h4>
                        <AZFilterList
                            items={links}
                            itemKey="name"
                            onItemHover={() => { }}
                            onItemLeave={() => { }}
                            selectedIndex={index}
                            renderComponent={(item) => {
                                if (item.external) {
                                    return (
                                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                                            {item.name} <i className="far fa-share-square icon" />
                                        </a>
                                    )
                                }
                                return <Link to={item.url}>{item.name}</Link>
                            }}
                        />
                    </div>
                </main>
            </PageLayout>
        )
    }
}
export default DirectoryOfServicesLayout
